import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { GiConfirmed } from 'react-icons/gi'

const Body = () => {

    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease'
        })
    }, [])

    return (
        <div className='body_text_container'>
            <div className='body_text_main_div'>
                <div>
                    <h3 data-aos="zoom-in"><strong> Queremos satisfacer a las personas y a sus mascotas</strong></h3>
                    <p data-aos="zoom-in">
                     Nuestra pasión por la calidad no solo se aplica a nuestros productos. Buscamos continuamente
                     impulsar las ganas de comprar de los dueños de animales domesticos ofreciendo un amplio surtido para tu punto de venta.
                  </p>
                </div>
            </div>
            <div className="why_us_div" id="Propuesta">
                <h4><strong style={{color:'#353336'}}>Nuestra  Propuesta</strong></h4>
                <div className="why_us_cards">
                    <div className="shy_us_card1">
                        <div>
                            <GiConfirmed className='card1_icon' />
                        </div>
                        <p> Confianza, calidad y responsabilidad hacia las mascotas </p>
                    </div>
                    <div className="shy_us_card2">
                        <div>
                            <GiConfirmed className='card2_icon' />
                        </div>
                        <p> Te ayudamos a aumentar el volumen de ventas </p>
                    </div>
                    <div className="shy_us_card3">
                        <div>
                            <GiConfirmed className='card3_icon' />
                        </div>
                        <p> Expertos en E-commerce, Paid Media y desarrollo de productos </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Body
